/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_LabelInputs */

const en_svc_agents_label = /** @type {(inputs: Svc_Agents_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI agent development`)
};

const lv_svc_agents_label = /** @type {(inputs: Svc_Agents_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI aģentu izstrāde`)
};

/**
* | output |
* | --- |
* | "AI agent development" |
*
* @param {Svc_Agents_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_label = /** @type {((inputs?: Svc_Agents_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_label(inputs)
	return en_svc_agents_label(inputs)
});